import React from 'react';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
  enableBackground: 'new 0 0 16 17',
};

const TrashIcon = ({ color = 'black', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg
      style={{ ...style, ...overrideStyles }}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      xmlSpace="preserve"
      {...attr}
    >
      <path style={{ fill: 'none', stroke: color, strokeMiterlimit: 10, shapeRendering: 'geometricPrecision' }} d="M13.7,3.3l-1.3,13.1H3.6L2.3,3.3" />
      <path
        style={{ fill: 'none', stroke: color, strokeMiterlimit: 10, shapeRendering: 'geometricPrecision' }}
        d="M6.3,3.3V2.7C6.3,1.7,7.1,1,8,1c0.9,0,1.7,0.7,1.7,1.7v0.6"
      />
      <path style={{ fill: 'none', stroke: color, strokeMiterlimit: 10, shapeRendering: 'geometricPrecision' }} d="M16,3.3H0" />
    </svg>
  );
};

export default TrashIcon;
